var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouRatingInputEcllipse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.84146,
    cy: 6.9249,
    rx: 6.84146,
    ry: 6.9249,
    fill: "#87B685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouRatingInputEcllipse);
export default __webpack_public_path__ + "static/media/aou-rating-input-ecllipse.b8b3edafdffca75f712f165df9355a7b.svg";
export { ForwardRef as ReactComponent };